import type { PaginatedResponse, TPAType } from "types/DataTypes.ts";
import { api } from "./api.ts";

export const tpaAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getTPAs: build.query<
      PaginatedResponse<TPAType>,
      {
        searchTerm?: string;
        limit?: number;
        offset?: number;
      }
    >({
      query: ({ searchTerm, limit, offset }) => {
        const params = new URLSearchParams();
        // DRF SearchFilter reads the term from `filter` (SEARCH_PARAM in
        // settings), not the default `search`; matches employer-api
        if (searchTerm) params.append("filter", searchTerm);
        if (limit !== undefined) params.append("limit", limit.toString());
        if (offset !== undefined) params.append("offset", offset.toString());

        return {
          url: `api/v1/tpas/?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["TPA"],
    }),
    getTPAById: build.query<TPAType, { id: string | number }>({
      query: ({ id }) => ({
        url: `api/v1/tpas/${id}/`,
        method: "GET",
      }),
      providesTags: ["TPA"],
    }),
    patchTPAById: build.mutation<
      TPAType,
      { id: string | number; data: Partial<TPAType> }
    >({
      query: ({ id, data }) => ({
        url: `api/v1/tpas/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["TPA", "Files"],
    }),
    createTPA: build.mutation<TPAType, { data: Partial<TPAType> }>({
      query: ({ data }) => ({
        url: `api/v1/tpas/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["TPA"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTPAsQuery,
  useGetTPAByIdQuery,
  usePatchTPAByIdMutation,
  useCreateTPAMutation,
} = tpaAPI;
